import { render, staticRenderFns } from "./EditarCompraDialog.vue?vue&type=template&id=6c3328b6"
import script from "./EditarCompraDialog.vue?vue&type=script&lang=js"
export * from "./EditarCompraDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports